module.exports = __webpack_public_path__ + "static/media/splash-bg.d80ba8d1.jpg";